/** The shared coin pile has transparent padding around its visible artwork. */
export const PRIZE_SHOT_COIN_SOURCE = {
  size: 256,
  x: 3,
  y: 35,
  width: 252,
  height: 186,
} as const;

/** The proportions used by the old, Prize Shot-specific cropped copy. */
export const PRIZE_SHOT_COIN_ART = {
  width: 320,
  height: 217,
} as const;

export const PRIZE_SHOT_COIN_URL = "assets/art/ui/one_plus_one_offer_screen/coins_icon.png?v=2";

/**
 * Bounds for drawing the full shared image so its non-transparent coin pile
 * occupies exactly the requested box. The padding stays outside that box.
 */
export function prizeShotCoinImageBounds( x: number, y: number, width: number, height: number )
  : { x: number; y: number; width: number; height: number }
{
  return {
    x: x - width * PRIZE_SHOT_COIN_SOURCE.x / PRIZE_SHOT_COIN_SOURCE.width,
    y: y - height * PRIZE_SHOT_COIN_SOURCE.y / PRIZE_SHOT_COIN_SOURCE.height,
    width: width * PRIZE_SHOT_COIN_SOURCE.size / PRIZE_SHOT_COIN_SOURCE.width,
    height: height * PRIZE_SHOT_COIN_SOURCE.size / PRIZE_SHOT_COIN_SOURCE.height,
  };
}
